interface LazyHeroVideoProps {
  poster: string;
  src: string;
  preload?: "auto" | "metadata" | "none";
}

export default function LazyHeroVideo({
  poster,
  src,
  preload = "auto",
}: LazyHeroVideoProps) {
  return (
    <video
      autoPlay
      loop
      muted
      playsInline
      poster={poster}
      preload={preload}
      className="h-full w-full object-cover"
    >
      <source src={src} type="video/mp4" />
    </video>
  );
}
